import { WsTooltipPlacement } from './ws-tooltip.types';

export const WS_TOOLTIP_GAP = 8;
export const WS_TOOLTIP_EDGE = 8;
export const WS_TOOLTIP_ARROW_CLAMP_MIN = 12;
export const WS_TOOLTIP_ARROW_HALF = 6;
export const WS_TOOLTIP_ARROW_CLAMP_MAX_OFFSET = 24;

export interface WsTooltipBounds {
  left: number;
  right: number;
  top: number;
  bottom: number;
}

export interface WsTooltipPositionResult {
  top: number;
  left: number;
  placement: WsTooltipPlacement;
  arrowLeft: number;
}

export function getDefaultWsTooltipBounds(): WsTooltipBounds {
  return {
    left: WS_TOOLTIP_EDGE,
    right: window.innerWidth - WS_TOOLTIP_EDGE,
    top: WS_TOOLTIP_EDGE,
    bottom: window.innerHeight - WS_TOOLTIP_EDGE,
  };
}

export function computeWsTooltipPosition(
  triggerRect: DOMRect,
  panelWidth: number,
  panelHeight: number,
  bounds: WsTooltipBounds = getDefaultWsTooltipBounds()
): WsTooltipPositionResult {
  const cx = triggerRect.left + triggerRect.width / 2;
  let placement: WsTooltipPlacement = 'above';
  let top: number;

  if (triggerRect.top - panelHeight - WS_TOOLTIP_GAP >= bounds.top) {
    top = triggerRect.top - panelHeight - WS_TOOLTIP_GAP;
    placement = 'above';
  } else {
    top = triggerRect.bottom + WS_TOOLTIP_GAP;
    placement = 'below';
  }

  let left = cx - panelWidth / 2;
  if (left < bounds.left) {
    left = bounds.left;
  }
  if (left + panelWidth > bounds.right) {
    left = bounds.right - panelWidth;
  }

  let arrowLeft = cx - left - WS_TOOLTIP_ARROW_HALF;
  arrowLeft = Math.max(
    WS_TOOLTIP_ARROW_CLAMP_MIN,
    Math.min(panelWidth - WS_TOOLTIP_ARROW_CLAMP_MAX_OFFSET, arrowLeft)
  );

  return { top, left, placement, arrowLeft };
}
